import { gql } from 'graphql-request';

export const GET_WORKFLOW_EVENTS_QUERY = gql`
  query getDuoWorkflowEvents($workflowId: AiDuoWorkflowsWorkflowID!) {
    duoWorkflowEvents(workflowId: $workflowId) {
      nodes {
        checkpoint
        errors
        metadata
      }
    }
  }
`;

export const GET_USER_WORKFLOWS = gql`
  query getUserWorkflows {
    duoWorkflowWorkflows {
      edges {
        node {
          id
          projectId
          humanStatus
          createdAt
          updatedAt
        }
      }
    }
  }
`;

export const GET_PROJECTS_QUERY = gql`
  query getProjects($ids: [ID!]) {
    projects(ids: $ids) {
      nodes {
        id
        fullPath
      }
    }
  }
`;
